import { confirmForgotPassword, forgotPassword, newPassword, renewAccessToken, signIn } from './auth'

export const authApi = {
  signIn,
  newPassword,
  renewAccessToken,
  forgotPassword,
  confirmForgotPassword,
}
